import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_740 implements Validator {

    public static id = 'CTRL_740';
    private message = 'error.ctr_740';


    public LOG: LogService = new LogService(CTRL_740);

    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_740.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondChampNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const thirdChampNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];
                const thirdChampCtrl = form.controls[thirdChampNameWithStepId];
                if (firstChampCtrl !== undefined && secondChampCtrl !== undefined && thirdChampCtrl !== undefined) {
                    if (firstChampCtrl.value?.length > 0  && secondChampCtrl.value?.length > 0 && thirdChampCtrl.value?.length > 0) {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    } else {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    }
                }
            }
        }
    }
}